export enum KeyAccessLevel {
    Disabled = 0,
    Pending = 5,
    Optional = 10,
    Required = 15
}

